<template>
  <div class="row mx-2 preview-table-background">
    <div class="p-3"><span>{{totalInvoices}} item<span v-if="totalInvoices > 1">s</span> added</span></div>
    <vue-good-table
      :columns="columns"
      :rows="invoices"
      :pagination-options="{enabled: this.paginationEnabled, ...paginationOptions}"
    ></vue-good-table>
        <div class="col-12 text-right px-0 pb-3 preview-table-data-background">
          <hr class="mt-0"/>
          <span class="pr-5 mb-3">
            <strong> Net amount: {{ currency }} {{netAmount}} </strong>
          </span>

        </div>

  </div>
</template>

<script>
import { VueGoodTable } from "vue-good-table";
import VGT_PAGINATION_OPTIONS from "../../../store/vgtPaginationOptions";

export default {
  name: "InvoiceDetails",
  components: {VueGoodTable},
  props: ['invoices', 'currency','companyCode','netAmount'],
  data() {
    return {
      paginationOptions: VGT_PAGINATION_OPTIONS.INVOICE_DETAIL_PAGINATION_OPTIONS
    }
  },
  computed: {
    totalInvoices() {
      return this.invoices && this.invoices.length > 0 ? this.invoices.length : 0
    },
    paginationEnabled() {
      return this.totalInvoices > 10
    },
    columns() {
      let that = this
      return [
        {
          label: "Description",
          field: "itemDescription",
          type: "string",
          thClass: "sorting",
          tdClass: "align-left",
          width: "20%",
        },
        {
          label: "G/L account",
          field: "glAccount",
          type: "string",
          thClass: "sorting hide-field-md",
          tdClass: "align-left hide-field-md",
          width: "20%",
        },
        {
          label: "Cost center",
          field: "costCenter",
          type: "string",
          thClass: "sorting",
          tdClass: "align-left",
          width: "20%",
        },
        {
          label: "WBS",
          field: "wbsElement",
          type: "string",
          thClass: "sorting hide-field-md",
          tdClass: "align-left hide-field-md",
          width: "20%",
        },
        {
          label: "Amount",
          field: function(rowObj) {
            if(that.currency) {
              return that.currency + ' ' + rowObj.itemTotal
            }
            return rowObj.itemTotal
          },
          type: "string",
          thClass: "sorting",
          tdClass: "align-left",
          width: "20%",
        }
      ]
    },
  }
}
</script>

<style scoped>

.preview-table-background {
  background-color: #F0F7FE
}

.preview-table-data-background {
  background-color: #DDECFD;
}

</style>

<style scoped src="@/assets/stylesheets/vgtStyles.css">
</style>